import React, { Component } from "react";
import { Navbar, Nav, NavItem } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { browserHistory } from 'react-router';
import cookie from 'react-cookie';

import './content/content.css';

class WebfineryNavbar extends Component {
    constructor(props) {
        super(props);

        this.state = { 
        	userQuery: "",
        	isLoggedIn: cookie.load('webfinery.jwt') != null
        };
        this.handleLogout = this.handleLogout.bind(this);
        this.handleDashboard = this.handleDashboard.bind(this);
    }

    handleLogout() {
    	this.setState({ isLoggedIn: false }, () => { browserHistory.push("/logout", { } ) });    	
    }

    handleDashboard() {
    	browserHistory.push("/dashboard", { } );
    }


    render() {

    	/*
		const popoverHoverFocus = (
		  <Popover id="popover-trigger-hover-focus" title="Dear Visitor...">
		    Please don't post Webfinery to Product Hunt before we complete our Private Beta phase. Thank you!
		  </Popover>
		);
		*/


		/*
		const preventProductHunt = (
			<div style={{color: 'white', fontWeight: 'bold', fontSize: '16px', background: '#DA552F', height: '45px', lineHeight: '45px', textAlign: 'center'}}>    				
			    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={popoverHoverFocus}>
			      <Button bsStyle="link" style={{color: 'white'}}>Please don't hunt as yet. (Why?)</Button>
			    </OverlayTrigger>
			</div>
		)
		*/

		/*
		const homeNav = (
            <LinkContainer to="/home">
                <NavItem eventKey={1}>
                    Home
                </NavItem>
            </LinkContainer>
        );
        */

        const searchNav = (
            <LinkContainer to="/search">
                <NavItem eventKey={2}>
                    Search
                </NavItem>
            </LinkContainer>
        );

        /*
        const plans = (
            <LinkContainer to="/search/plans">
                <NavItem eventKey={3}>
                    Plans
                </NavItem>
            </LinkContainer>
        );
        */

        const listsNav = (
            <LinkContainer to="/lists">
                <NavItem eventKey={3}>
                    Lists
                </NavItem>
            </LinkContainer>
        );

        const cloudNav = (
            <LinkContainer to="/cloud">
                <NavItem eventKey={4}>
                    Cloud
                </NavItem>
            </LinkContainer>
        );        

        const loginNav = (
            <LinkContainer to="/login">
                <NavItem eventKey={5}>
                    Log in
                </NavItem>
            </LinkContainer>
        );

        /*
        const logoutNav = (
            <NavItem eventKey={5} onClick={this.handleLogout}>
                Log out
            </NavItem>
        );
        */

        const dashboardNav = (
        	<LinkContainer to="/dashboard">
	        	<NavItem eventKey={6}>
	            	<div className="dashboardButton">Dashboard</div>
	            </NavItem>
	        </LinkContainer>
        );

        const signupNav = (            
	        <LinkContainer to="/signup">
	                <NavItem eventKey={7}>
	                    <div style={{'color':'#449D44'}}>Sign up</div>
	                </NavItem>	            
	        </LinkContainer>
        );                
/*
        if (axios.defaults.headers.common["Authorization"]) {
            authNav = logoutNav;
        }
*/
        return (
        	<div>
        		{/*preventProductHunt*/}
	            <Navbar fluid={true}>

	                <Navbar.Header>
	                    <Navbar.Brand>
	                        <div>
	                            <a href="/">
	                                <div className="logo">Webfinery</div>
	                            </a>
	                        </div>
	                    </Navbar.Brand>
	                    <Navbar.Toggle />
	                </Navbar.Header>

	                <Navbar.Collapse>
	                	<Nav pullRight>

	                    	{searchNav}

	                    	{listsNav}

	                    	{cloudNav}

	                        <LinkContainer to="/consulting">
	                            <NavItem eventKey={6}>
	                                Consulting
	                            </NavItem>
	                        </LinkContainer>

	                        {this.state.isLoggedIn ? dashboardNav : loginNav}
	                        {this.state.isLoggedIn ? null : signupNav }

	                	</Nav>                    
	                </Navbar.Collapse>
	            </Navbar>
	        </div>
        );
    }
}

export default WebfineryNavbar;



// WEBPACK FOOTER //
// ./src/WebfineryNavbar.js